const ratesSagaNamespace = 'groups-saga';
export const LOAD_ROLES_FOR_RATES = `${ratesSagaNamespace}/LOAD_ROLES_FOR_RATES`;
export const LOAD_GROUPS_FOR_STUDY_PROGRAM = `${ratesSagaNamespace}/LOAD_GROUPS_FOR_STUDY_PROGRAM`;
export const DELETE_GROUP = `${ratesSagaNamespace}/DELETE_GROUP`;
export const ADD_MEMBER_IN_GROUP = `${ratesSagaNamespace}/ADD_MEMBER_IN_GROUP`;
export const LOAD_ALL_ADMINS = `${ratesSagaNamespace}/LOAD_ALL_ADMINS`;
export const CONSULT_DELETE = `${ratesSagaNamespace}/CONSULT_DELETE`;
export const UPDATE_PRIMARY_WRITER = `${ratesSagaNamespace}/UPDATE_PRIMARY_WRITER`;
